/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies */
// Extend From
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { action, computed } from '@ember/object';
import { or } from '@ember/object/computed';
import { service } from '@ember/service';
// External Imports
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import config from 'linced-admin/config/environment';
// Internal Imports
import EnrolmentLogResource from 'linced-admin/enums/enrolment-log-resource';

export default class ApplicationController extends Controller {
  @service
  session;

  @service
  permissions;

  @service
  router;

  @service
  roles;

  EnrolmentLogResource = EnrolmentLogResource;
  Jurisdiction = Jurisdiction;
  sifEnabled = config.APP.sifEnabled;
  publicRoutes = config.APP.publicRoutes;

  @computed('router.currentRouteName')
  get isPublicRoute() {
    let current = this.router.currentRouteName;
    return this.publicRoutes.includes(current);
  }

  @tracked
  leftSideBarOpen;

  @action
  setLeftSideBarOpen(value) {
    this.leftSideBarOpen = value;
  }

  // Local toggle state, set only by `toggleExpandedMenuItem`. Deliberately
  // not tied to the current route: it should only change on user click.
  @tracked
  expandedMenuItem = null;

  @computed('session.scopes.[]')
  get isSuperAdmin() {
    return this.permissions.meet(Scopes.LINCED_ADMIN);
  }

  @or('isSuperAdmin', 'roles.hasFullAccessRole', 'roles.hasManageRole')
  showManagementMenu;

  @or('isSuperAdmin', 'roles.hasFullAccessRole', 'roles.hasCommunicationRole')
  showCommunicationMenu;

  @or('roles.hasAPIActivationAccess', 'isSuperAdmin')
  showSuperMenu;

  @action
  logout() {
    this.session.logout('application');
  }

  @action
  toggleExpandedMenuItem(value, ev) {
    if (this.expandedMenuItem === value) {
      value = null;
    }
    this.expandedMenuItem = value;
    ev.stopPropagation();
  }
}
